const intranetService = `/v1/central-service/`;
const cfApprovalService = "/v1/cf-approval-service/";
const cfApprovalServicev2 = "/v2/cf-approval-service/";
const bdLeadService = "/v1/bd-leads-service/";
// Capex Calculator is registered in subway-cf-approval-api's routes/v2 aggregator (same
// convention as AOP_SITES below), which app.js mounts under /v2/cf-approval-service — so the
// real path is /v2/cf-approval-service/capex-calculator, not a standalone top-level path.
const capexCalculatorService = `${cfApprovalServicev2}capex-calculator/`;
export const REST_URLS = {
  LOGIN: "/v1/cf-approval-service/auth/login",
  LOGOUT: `${intranetService}auth/logout`,
  // REFRESH_TOKEN: "/v1/cf-approval-service/auth/refresh-tokens",
  REFRESH_TOKEN: `${intranetService}auth/refresh-tokens-app`,
  CREATE_DOCUMENT: "/v1/cf-approval-service/form",
  UPDATE_DOCUMENT: "/v1/cf-approval-service/form/update-form-docs/",
  UPLOAD_FILES: "/v1/cf-approval-service/misc/upload",
  APPROVED_FORMS: "/v1/cf-approval-service/form/approved",
  REJECTED_FORMS: `${cfApprovalService}form/reject-form`,
  UNAPPROVED_FORMS: "/v1/cf-approval-service/form/non-approved",
  APPROVE_FORM: "/v1/cf-approval-service/form/approve-form",
  INVITE_USER: "/v1/cf-approval-service/users/invite",
  LIST_USERS: "/v1/cf-approval-service/users",
  LIST_ALL_USERS: `${intranetService}other-app/all-user-names`,
  REPORTS: "/v1/cf-approval-service/form/all-restaurant",
  SET_PASSWORD: "/v1/cf-approval-service/users/save-password/",
  UPLOAD_ATTACHMENT_FILES: "/v1/cf-approval-service/tickets/upload/attachment/",
  ALL_RESTARANT_NAMES: "/v1/cf-approval-service/form/restaurant-names-list",
  EDIT_RESTAURANT_ID: "/v1/cf-approval-service/form/update-restaurantid",
  INTRANET_LOGIN: `${intranetService}auth/login-with-token`,
  GET_ALL_STORES: `${intranetService}stores`,
  DELETE_APPROVAL: `${cfApprovalService}form/`,
  REJECT_APPROVAL: `${cfApprovalService}form/reject-form/`,
  FIELD_NAME: `${cfApprovalService}form/field-list`,
  DASHBOARD: `${cfApprovalService}form/dashboard`,
  UPLOAD_FLATSHEET: `${cfApprovalService}form/upload-flatsheet/`,
  GET_LEAD_LIST: `${bdLeadService}lead/cf/get-leads-list`,
  GET_FORM_BY_LEAD: `${cfApprovalService}form/get-for-by-lead/`,
  PRICE_COHORT: `${cfApprovalService}price-cohort`,
  ORDERING_PLATFORM: `${cfApprovalService}ordering-platform`,
  // NSO CF approval endpoints
  CF_V2: `${cfApprovalServicev2}`,
  CF_V2_STEP_MASTER: `${cfApprovalServicev2}step-master`,
  CF_V2_STEP_MASTER_SEED: `${cfApprovalServicev2}step-master/seed`,
  CF_V2_APPROVALS: `${cfApprovalServicev2}`,
  CF_V2_APPROVALS_COUNTS: `${cfApprovalServicev2}counts`,
  CF_V2_MOVE_STEPS: `${cfApprovalServicev2}move-steps`,
  AOP_SITES: `${cfApprovalServicev2}aop-sites`,
  AOP_SITES_UPLOAD: `${cfApprovalServicev2}aop-sites/upload`,
  CF_FINANCIAL_UPLOAD: `${cfApprovalServicev2}cf-financial/`,
  CF_FINANCIAL_ALL: `${cfApprovalServicev2}cf-financial/all`,
  CF_V2_PIPELINE_REPORT: `${cfApprovalServicev2}report/pipeline`,
  CF_V2_REPORT_CONFIG: `${cfApprovalServicev2}report/config`,
  CF_V2_EXCEPTION_APPROVERS: `${cfApprovalServicev2}exception-approvers`,
  CF_V2_API_CLIENTS: `${cfApprovalServicev2}api-clients`,

  // Capex Calculator — base paths; consumers append /<cfId>, /<id>, /upload, /export as needed
  // (same convention as CF_V2 above, e.g. `${REST_URLS.CAPEX_RESULT}${cfId}/export`).
  CAPEX_INPUT_FORM: `${capexCalculatorService}input-form`,
  CAPEX_CALCULATE: `${capexCalculatorService}calculate`,
  CAPEX_PREVIEW: `${capexCalculatorService}preview`,
  CAPEX_RESULT: `${capexCalculatorService}`, // + <cfId> [+ "/export"]
  CAPEX_INPUT_MASTER: `${capexCalculatorService}master/input-fields`,
  CAPEX_RATE_MASTER: `${capexCalculatorService}master/rates`,
  CAPEX_BOQ_MASTER: `${capexCalculatorService}master/boq`,
  CAPEX_AOP_MASTER: `${capexCalculatorService}master/aop-budget`,
  CAPEX_OUTPUT_TEMPLATE_MASTER: `${capexCalculatorService}master/output-templates`,
};

export const SLUG = "cf-approval";
export const CF_APPROVAL_COMMON_ROUTE = "/cf-approval";
export const userRedirectionRoute = `${CF_APPROVAL_COMMON_ROUTE}/approval`;
